import dayjs from 'dayjs';
import { ChampCompteRendu } from '../compte-rendu/champ-compte-rendu.model';
import { Coordinates } from '../coordinates.model';
import { INommable } from '../nommable.interface';
import { VerifMateriel } from '../verif-materiel.model';
import { UserEvent } from './user-event.model';

export class DebutVacationInterventionEvent extends UserEvent {
  public static NAME = 'DEBUT_INTER_EVENT';

  constructor(
    public idCreneau: string,
    public idVacation: string,
    public debut: dayjs.Dayjs,
    public site: INommable,
    public idTournee?: string,
    public verificationMateriel?: VerifMateriel,
    public champsPersonnalises: ChampCompteRendu[] = [],
    public idConsignes: string[] = [],
    coordinates?: Coordinates
  ) {
    super(DebutVacationInterventionEvent.NAME, undefined, coordinates);
  }

  public static hydrate(obj: DebutVacationInterventionEvent): DebutVacationInterventionEvent {
    return new DebutVacationInterventionEvent(
      obj.idCreneau,
      obj.idVacation,
      obj.debut,
      obj.site,
      obj.idTournee,
      obj.verificationMateriel,
      obj.champsPersonnalises,
      obj.idConsignes,
      obj.coordinates
    );
  }
}
